import { useEffect, useState } from 'react';
import styles from './pending.module.scss';
import { useTranslation } from 'react-i18next';

export type PendingProps = {
    size?: number;
    showTextDelay?: number;
};

export const Pending = ({ size, showTextDelay = 0 }: PendingProps) => {
    const { t } = useTranslation('common');
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        if (showTextDelay > 0) {
            const timer = setTimeout(() => {
                setShowText(true);
            }, showTextDelay * 1000);
            return () => clearTimeout(timer);
        }
    }, [showTextDelay]);

    return (
        <section className={styles.spinnerBlock}>
            <div className={styles.biLoading} style={size ? ({ '--size': `${size}px` } as React.CSSProperties) : {}}>
                <span className={styles.t} />
                <span className={styles.b} />
                <span className={styles.r} />
                <span className={styles.l} />
            </div>
            {showText && <div className={styles.spinnerText}>{t('common:pendingText')}</div>}
        </section>
    );
};
